import { inject, PLATFORM_ID } from '@angular/core';
import { HttpContextToken, HttpErrorResponse, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from './AuthService';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../_environments/environment';
import { GlobalService } from './GlobalService';

export const RETRY_REQUEST_COUNT = new HttpContextToken<number>(() => 0);

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  // Inject the current `AuthService` and use it to get an authentication token:

  // Clone the request to add the authentication header.
  const authService = inject(AuthService)
  const _globalService = inject(GlobalService);
  const platformId = inject(PLATFORM_ID);

  // OAuth2 token/authorize/revoke and the session-login bridge must not carry the app bearer header.
  if (req.url.includes('/oauth2/token') || req.url.includes('/oauth2/authorize') || req.url.includes('/oauth2/revoke') || req.url.includes('/login/session'))
    return next(req);

  req = updateHeader(req, _globalService, platformId);

  const retrycount = req.context.get(RETRY_REQUEST_COUNT);
  return next(req).pipe(
    catchError((error, caught) => {
      if (error instanceof HttpErrorResponse) {

        //makes sure a tokenrefresh is only done when it is expired, not when a resetpassword is failed
        if (req.url.endsWith('/user/changepassword/loggedin'))
          return throwError(() => error);
        if (!_checkTokenExpiryErr(error))
          return throwError(() => error);

        return authService.doTokenRefresh().pipe(switchMap(data => {
          req.context.set(RETRY_REQUEST_COUNT, retrycount + 1)
          req = updateHeader(req, _globalService, platformId);
          return next(req);
        }))
      }
      return caught;

    })
  );
}

function updateHeader(req: HttpRequest<any>, _globalService: GlobalService, platformId: any) {

  const env = environment;

  if (isPlatformBrowser(platformId)) {
    const authToken = JSON.parse(localStorage.getItem('token'));
    if (authToken !== null) 
      req = req.clone({ headers: req.headers.set('Authorization', 'Bearer ' + authToken.access_token ) }); 
  }
  if (!req.headers.has('Content-Type'))
    req = req.clone({ headers: req.headers.set( 'Content-Type', 'application/json' ) });

  if (!req.headers.has('Accept'))
    req = req.clone({ headers: req.headers.set( 'Accept', 'application/json' ) });

  req = req.clone({ headers: req.headers.set( 'brand', String(env.brandid) ) });

  let lang = 'NL'
  if (_globalService && _globalService.getLanguage && typeof _globalService.getLanguage === 'function') 
    lang = _globalService.getLanguage().toUpperCase();

  if (!req.headers.has('language')) 
    req = req.clone({     headers: req.headers.set( 'language', lang )  });
  
  return req;
}

function _checkTokenExpiryErr(error: HttpErrorResponse): boolean {

  return (
    error.status &&
    error.status === 401
  );
}

